export interface RequestAddCLAManagerDesigneeInput {
  firstName?: string;
  lastName?: string;
  companyId: string;
  projectId: string;
  userEmail?: string;
}
